module.exports = __webpack_public_path__ + "f5c0f4676701d1b6dd076a64a717c16b.svg";